import { createVNode, render, VNode } from 'vue'
import type { AppContext } from 'vue'

export function createComponent(component: any, props?: any, appContext?: AppContext) {
  const container = document.createElement('div')
  const randomString = Math.random().toString(36).slice(-8)
  const wrapClass = `component-wrap-${randomString}`
  container.setAttribute('class', wrapClass)
  document.body.appendChild(container)

  let vnode: VNode | null = null

  const destroy = () => {
    if (vnode) {
      render(null, container)
      vnode = null
      container.remove()
    }
  }

  vnode = createVNode(component, {
    ...props,
    onDestroy: destroy,
  })

  if (appContext) {
    vnode.appContext = appContext
  }

  render(vnode, container)

  return {
    destroy,
    vnode,
  }
}
